export default __webpack_public_path__ + "static/media/orderCategory.01bd910e.png";